export const collectionTypes = {
  lopbandet: 'lopbandet',
  pink: 'rosa',
  memorial: 'memorial',
  celebration: 'celebration',
  normal: 'normal',
  default: 'default',
  memorial_page: 'memorial_page'
};
